import _inRange from "lodash/inRange";
import _get from "lodash/get";
import _find from "lodash/find";
import _defaultTo from "lodash/defaultTo";
import { stateAdjustments, creditScoreRanges, defaultCreditScoreRange } from './lib/rate-adjustments';
export var getCreditScoreRangeByValue = function getCreditScoreRangeByValue(creditScoreRangeValue) {
  return _find(creditScoreRanges, {
    value: creditScoreRangeValue
  }) || defaultCreditScoreRange;
};

var getStateAdjustment = function getStateAdjustment(_ref) {
  var loanTerm = _ref.loanTerm,
      state = _ref.state;
  return _get(stateAdjustments, [loanTerm, state], 0);
};
/**
 * Returns the interest rate for a credit score range given a base annual
 * interest rate, loan term and state
 * @function
 * @param {Object} data
 * @param {Object} data.creditScoreRange The credit score range (as defined by `creditScoreRanges`)
 * @param {Number} data.baseAnnualInterestRate The base annual interest rate
 * @param {Number} data.loanTerm The loan term
 * @param {String} data.state The state ('CA' etc.)
 * @return {Num} the interest rate
 */


var getAnnualInterestRateForCreditScoreRange = function getAnnualInterestRateForCreditScoreRange(_ref2) {
  var creditScoreRange = _ref2.creditScoreRange,
      baseAnnualInterestRate = _ref2.baseAnnualInterestRate,
      loanTerm = _ref2.loanTerm,
      state = _ref2.state;
  return baseAnnualInterestRate + creditScoreRange.adjustment + getStateAdjustment({
    loanTerm: loanTerm,
    state: state
  });
};

export { creditScoreRanges, defaultCreditScoreRange };
/**
 * Retrieve the credit score range associated with a credit score
 * @function
 * @param {Number} creditScore the credit score
 * @return {Object} the credit score range
 */

export var getCreditScoreRangeForCreditScore = function getCreditScoreRangeForCreditScore(creditScore) {
  return _defaultTo(_find(creditScoreRanges, function (el) {
    return _inRange(creditScore, el.range[0], el.range[1]);
  }), defaultCreditScoreRange);
};
/**
 * Returns the interest rate for a credit score range value
 * @todo clarify creditScoreRangeValue
 * @todo clarify baseAnnualInterestRate, in decimal or percent?
 * @function
 * @param {Object} data
 * @param {Number} data.creditScoreRangeValue Value of the credit score range
 * @param {Number} data.baseAnnualInterestRate Base annual interest rate
 * @param {Number} data.loanTerm The loan term in years
 * @param {String} data.state The state abbr
 * @return {Number} the interest rate
 */

export var getAnnualInterestRateForCreditScoreRangeValue = function getAnnualInterestRateForCreditScoreRangeValue(_ref3) {
  var creditScoreRangeValue = _ref3.creditScoreRangeValue,
      baseAnnualInterestRate = _ref3.baseAnnualInterestRate,
      loanTerm = _ref3.loanTerm,
      state = _ref3.state;
  return getAnnualInterestRateForCreditScoreRange({
    creditScoreRange: getCreditScoreRangeByValue(creditScoreRangeValue),
    baseAnnualInterestRate: baseAnnualInterestRate,
    loanTerm: loanTerm,
    state: state
  });
};
/**
 * Returns the interest rate for a specific credit score
 * @todo Clarify return value, decimal or percent?
 * @todo clarify baseAnnualInterestRate, in decimal or percent?
 * @function
 * @param {Object} data
 * @param {Number} data.creditScore The credit score
 * @param {Number} data.baseAnnualInterestRate The base annual interest rate
 * @param {Number} data.loanTerm The loan term
 * @param {String} data.state The state ('CA' etc.)
 * @return {Number} the interest rate
 */

export var getAnnualInterestRateForCreditScore = function getAnnualInterestRateForCreditScore(_ref4) {
  var creditScore = _ref4.creditScore,
      loanTerm = _ref4.loanTerm,
      state = _ref4.state,
      baseAnnualInterestRate = _ref4.baseAnnualInterestRate;
  return getAnnualInterestRateForCreditScoreRange({
    creditScoreRange: getCreditScoreRangeForCreditScore(creditScore),
    baseAnnualInterestRate: baseAnnualInterestRate,
    loanTerm: loanTerm,
    state: state
  });
};